module.exports = __webpack_public_path__ + "static/media/AlgoHome.0a281c58.jpg";